import { useMutation, useQueryClient } from "@tanstack/react-query";
import { processedApplicationsService } from "@/services/process";

// Only creation mutation remains; listings use unified incoming hooks
export const useCreateProcessedApplication = () => {
  const queryClient = useQueryClient();
  return useMutation<any, Error, any>({
    mutationFn: processedApplicationsService.createProcessedApplication,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["pending-applications"] });
      queryClient.invalidateQueries({ queryKey: ["pending-applications-process"] });
      queryClient.invalidateQueries({ queryKey: ["single-application"] });
    },
  });
};